import MobileDetect from 'mobile-detect';

let _facebook = false;
let _initalised = false;
let _md;
let _twitter = false;

const _init = function _init() {
  _facebook = navigator.userAgent.match(/FBAN/i) != null;
  _md = new MobileDetect(window.navigator.userAgent);
  _twitter = window.navigator.userAgent.match(/Twitter/i) != null;
  _initalised = true;
};

const is = function is(string) {
  if (!_initalised) _init();
  return _md.is(string);
};

const isFacebook = function isFacebook() {
  if (!_initalised) _init();
  return _facebook;
};

const isiOS = function isiOS() {
  if (!_initalised) _init();
  return _md.os() === 'iOS';
};

const isTwitter = function isTwitter() {
  if (!_initalised) _init();
  return _twitter;
};

const md = function md() {
  if (!_initalised) _init();
  return _md;
};

const os = function os() {
  if (!_initalised) _init();
  return _md.os();
};

const version = function version(key) {
  if (!_initalised) _init();
  return _md.version(key);
};

const browserDetector = {
  is,
  isFacebook,
  isiOS,
  isTwitter,
  md,
  os,
  version,
};

export default browserDetector;
